import { ILargeTextEditorParams, LargeTextCellEditor } from 'ag-grid-community'

interface IReadOnlyLargeTextEditorParams extends ILargeTextEditorParams {
  readOnly?: boolean
  readOnlyMessage?: string
}

export class ReadOnlyLargeTextCellEditor extends LargeTextCellEditor {
  init(params: IReadOnlyLargeTextEditorParams): void {
    super.init(params)

    if (!params.readOnly) {
      return
    }

    const textArea = this.getGui().querySelector('textarea')
    const readOnlyMessage =
      params.readOnlyMessage ||
      'Du har inte behörighet att redigera kommentaren'

    if (textArea) {
      textArea.setAttribute('disabled', 'true')
      textArea.setAttribute('aria-label', readOnlyMessage)
      textArea.setAttribute('title', readOnlyMessage)
      textArea.style.opacity = '0.7'
      textArea.style.color = 'var(--ag-foreground-color)'
      textArea.style.webkitTextFillColor = 'var(--ag-foreground-color)'
      textArea.style.backgroundColor =
        'var(--ag-input-disabled-background-color)'
      textArea.style.borderColor = 'var(--ag-input-disabled-border-color)'
    }
  }
}
